/**
 * Escala horizontal Shorts a partir de tablet (md).
 * md 32px | lg 48px | xl 128px | 2xl+ 256px
 */
export const shortsHorizontalPaddingMdUp =
	'md:px-8 lg:px-12 xl:px-32 2xl:px-64';

/**
 * Barra (título “Shorts” + linha de filtros/suggest).
 * Mobile: 16px esquerda e direita — título alinhado ao campo de busca.
 */
export const shortsBarContentContainerX = `px-4 ${shortsHorizontalPaddingMdUp}`;

/**
 * Listagem /shorts: mobile 2px; md+ mesma escala da barra.
 */
export const shortsListingPaddingX = `px-[2px] ${shortsHorizontalPaddingMdUp}`;
